import { createProviderToken } from '@core/common-legacy';

export interface CompanySubscriptionContract {
  getBlockAt: () => string;
  isManual: () => boolean;
  isPastDue: () => boolean;
  isExpiredExplicit: () => boolean;
  isTrial: () => boolean;
  isExpired: () => boolean;
  isTrialEnded: () => boolean;
  isInactive: () => boolean;
  isBlocked: () => boolean;
}

export const {
  provide: provideSubscriptionStatusContract,
  inject: injectSubscriptionStatusContract,
} = createProviderToken<CompanySubscriptionContract>('SubscriptionService based token')();
